<div class="login-page">
  <div class="login-hero">
    <img src="./assets/login-hero.jpeg" alt="Equipo Bild en bodega" class="login-hero-img" />
    <div class="login-hero-overlay"></div>
    <div class="login-hero-content">
      <h2 class="login-hero-title">Control total de tu almacén</h2>
      <p class="login-hero-text">Administra artículos, tarimas y órdenes.</p>
    </div>
  </div>

  <div class="login-panel">
    <div class="login-card">
      <div class="login-brand">
        <img src="./assets/Bild-Portal.svg" height="64" class="login-logo" alt="Bild" />
        <h1 class="login-title">Bienvenido</h1>
        <p class="login-subtitle">Inicia sesión para continuar</p>
      </div>

      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <div class="form-group">
          <label for="username">Usuario</label>
          <p-iconfield>
            <p-inputicon class="pi pi-user" />
            <input pInputText id="username" type="text" formControlName="username" (input)="onInputChange()"
              placeholder="Usuario" class="w-full" required />
          </p-iconfield>
        </div>

        <div class="form-group">
          <label for="password">Contraseña</label>
          <p-password id="password" formControlName="password" (input)="onInputChange()" placeholder="Contraseña"
            [feedback]="false" [toggleMask]="true" class="w-full" inputStyleClass="w-full" required />
        </div>

        @if (loginError) {
          <p-message severity="error" [text]="loginError" [closable]="false" class="w-full login-error" />
        }

        <div class="login-actions">
          <p-button type="submit" label="Iniciar Sesión" icon="pi pi-sign-in" iconPos="right"
            [disabled]="loginForm.invalid" />
        </div>
      </form>
    </div>
  </div>
</div>
